
import LocaleFormatter from './format/LocaleFormatter';

class AnimatedCounter {
	constructor(counterElement) {
		this._counterElement = counterElement;
		this._value = parseInt(counterElement.dataset.value, 10);
		this._step = 100;
	}

	start() {
		if (!this._value) {
			return;
		}

		const extractNumbers = (str) => {
			return parseInt(str.replace(/\D/g, ''), 10);
		};

		const interval = setInterval(() => {
			const currentValue = extractNumbers(this._counterElement.innerHTML);

			let newValue = currentValue + this._step;
			if (newValue > this._value) {
				newValue = this._value;
			}
			this._counterElement.innerHTML = LocaleFormatter.number(newValue);

			if (newValue === this._value) {
				clearInterval(interval);
			}
		}, 25);
	}
}

export default AnimatedCounter;
